import { Flex } from '@chakra-ui/react'
import {
  AdjustmentsHorizontalIcon,
  BadgeIndicator,
  Popover,
  Switch,
  ToggleButton,
} from 'components'
import { useCurrentUser } from 'components/providers'
import { startCase } from 'lodash'
import { useEffect } from 'react'
import { EntevatePermission } from 'types'
import { useEntevatePermission, useShowDevelopmentFeatures } from 'utils'

export default function EntevateAdminControl() {
  const [entevatePermission, setEntevatePermission] = useEntevatePermission()
  const [showDevelopmentFeatures, setDevelopmentFeatures] = useShowDevelopmentFeatures()

  const user = useCurrentUser()
  const palette = 'primary'

  useEffect(() => {
    if (!user) return

    if (user.isAdmin) {
      if (!entevatePermission) setEntevatePermission('entevate')
    } else {
      if (entevatePermission) setEntevatePermission(undefined)
      if (showDevelopmentFeatures) setDevelopmentFeatures(false)
    }
  }, [user])

  if (!user?.isAdmin || !entevatePermission) return null

  return (
    <Popover
      closeOnBlur
      autoFocus
      header="Entevate Admin Control"
      contentProps={{ p: 2 }}
      triggerNode={
        <BadgeIndicator value={entevatePermission !== 'entevate' || showDevelopmentFeatures}>
          <AdjustmentsHorizontalIcon cursor="pointer" type="outline" />
        </BadgeIndicator>
      }
    >
      <Flex direction="column" gap={4}>
        <Switch
          colorScheme={palette}
          label="Development Features"
          isChecked={showDevelopmentFeatures}
          onChange={() => setDevelopmentFeatures(!showDevelopmentFeatures)}
        />
        <ToggleButton
          label="Permission"
          options={permissions.map(permission => ({
            value: permission,
            label: startCase(permission),
          }))}
          value={entevatePermission}
          onChange={setEntevatePermission}
        />
      </Flex>
    </Popover>
  )
}

const permissions: EntevatePermission[] = ['entevate', 'admin', 'editor', 'viewer']
